import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "py-2 rounded-xl bg-gray-50 text-center"
};
const _hoisted_2 = {
  class: "text-sm pb-2"
};
const _hoisted_3 = {
  class: "font-bold"
};
const _hoisted_4 = {
  class: "text-gray-600"
};
import MatchComponent from "@/modules/competitions/components/Match.vue";
import { Season } from "@/modules/season/entity";
export default /*#__PURE__*/_defineComponent({
  __name: 'MatchPanel',
  props: {
    match: null
  },
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const season = ref(([__temp, __restore] = _withAsyncContext(() => Season.current()), __temp = await __temp, __restore(), __temp));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.match.matchday.division.competition.name), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$date(__props.match.matchday.scheduledAt)), 1)]), _createVNode(MatchComponent, {
        match: __props.match
      }, null, 8, ["match"])]);
    };
  }
});